export default "__VITE_ASSET__DFQPzSDu__"